import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "empty"
};
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "empty__img"
}, null, -1);
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, "点击“+”或按钮添加链接，创建下载任务", -1);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("h3", null, "暂无" + _toDisplayString(_ctx.taskType === 'ing' ? '下载中' : '已完成') + "任务", 1), _hoisted_3, _createElementVNode("span", {
    class: "button-create",
    onClick: _cache[0] || (_cache[0] =
    //@ts-ignore
    (...args) => _ctx.handleAdd && _ctx.handleAdd(...args))
  }, "创建任务")]);
}